import React from "react";
import LanguageSelector from "../../../atoms/LanguageSelector";

interface RegistrationHeaderProps {
  logo?: string;
  entityName?: string;
  entityDescription?: string;
  formDescription?: string;
}

export const RegistrationHeader: React.FC<RegistrationHeaderProps> = ({
  logo,
  entityName,
  entityDescription = "",
  formDescription = "",
}) => {
  return (
    <div className="relative text-center mb-8">
      <div className="absolute top-0 end-0">
        <LanguageSelector variant="compact" />
      </div>

      {logo && (
        <div className="mb-6">
          <img
            src={logo}
            alt={entityName || "Logo"}
            className="mx-auto h-16 w-auto rounded-md"
          />
        </div>
      )}
      <h1 className="text-2xl font-bold text-gray-900 mb-2">{entityName}</h1>
      {entityDescription && (
        <p className="text-gray-500 text-sm mb-2 whitespace-pre-line">
          {entityDescription}
        </p>
      )}
      {formDescription && (
        <p className="text-gray-600 font-medium whitespace-pre-line">
          {formDescription}
        </p>
      )}
    </div>
  );
};
